import { IProjectDep } from '../types';
import { EntityService } from './EntityService';

export class ProjectDepService extends EntityService<IProjectDep> {
    constructor() {
        super(`/ProjectDeps`);
    }
}
